import { useEffect, useState } from "react";

const useTable = ({
  fields,
  data,
  uniqueID,
  multiSelect,
  clear,
  handleSelect,
  disabledKey,
}) => {
  const [checked, setChecked] = useState([]);

  const tableFields = fields ? Object?.values(fields) : [];

  useEffect(() => {
    if (clear) {
      setChecked([]);
    }
  }, [clear]);

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key].label === value);
  }

  const handleOnChange = (id) => {
    if (checked?.includes(id)) {
      let filteredIds = checked?.filter((a) => a != id);
      setChecked(filteredIds);
      handleSelect(filteredIds);
    } else {
      if (multiSelect) {
        setChecked((state) => [...state, id]);
        handleSelect([...checked, id]);
      } else {
        setChecked([id]);
        handleSelect([id]);
      }
    }
  };
  const handleCheckAll = () => {
    const currentPageIds = data
      ?.filter((item) => item?.[uniqueID] && !item[disabledKey])
      ?.map((item) => item[uniqueID]) || [];

    const allCurrentPageSelected = currentPageIds.length > 0 &&
      currentPageIds.every((id) => checked?.includes(id));

    if (allCurrentPageSelected) {
      // Uncheck only current page items, keep other pages' selections
      const updated = checked?.filter((id) => !currentPageIds.includes(id)) || [];
      setChecked(updated);
      handleSelect(updated);
    } else {
      // Add current page items to existing selections (avoid duplicates)
      const updated = [...new Set([...(checked || []), ...currentPageIds])];
      setChecked(updated);
      handleSelect(updated);
    }
  };

  const checkedRowCount = checked?.length;
  return {
    tableFields,
    checkedRowCount,
    checked,
    getKeyByValue,
    handleOnChange,
    handleCheckAll,
  };
};

export default useTable;
